module.exports = __webpack_public_path__ + "static/img/shengchan.11fe007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/srmCloud/shengchan.png
// module id = 481
// module chunks = 12